import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes with clsx for conditional class composition */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
